
import * as mathUtil from '@/common/js/mathutil.js'

import Decimal from '@/math/types/decimal.js'
import Equation from '@/math/types/equation.js'

export default {
  title: 'Add numbers up to 9',
  operation: 'arithmetic-integer',
  instruction: 'What is the sum?',
  config: { nProblems: 10, maxPlaces: 2, displayMode: 'random' },
  equation: function () {
    var lhs1 = new Decimal(mathUtil.randomIntUniform(0, 9))
    var lhs2 = new Decimal(mathUtil.randomIntUniform(0, 9))

    return new Equation('+', lhs1, lhs2, lhs1.plus(lhs2))
  }
}



// WEBPACK FOOTER //
// ./src/math/drills/add/adduacz.js